import React from 'react';
import DashboardLayout from 'layouts/Dashboard';
import { Row, Col, Space } from 'antd';
import Container from 'components/Container';
import { BuildOutlined, HomeOutlined } from '@ant-design/icons';
import { PRIMARY, SECONDARY } from 'utils/colors';
import StateList from 'components/stateList';

import MapGL from 'components/map';
import Bar from 'components/demo/charts/bar';
import Gauge from 'components/demo/charts/gauge';
import YOY from 'components/demo/charts/yoy';
import YTD from 'components/demo/charts/ytd';

import { data } from 'data/sales-list';

export default function RespMap() {
  return (
    <DashboardLayout title="Resp Map">
      <Row gutter={5}>
        <Col md={6}>
          <Container title="States">
            <div style={{ height: 753, overflowY: 'scroll' }}>
              <StateList data={data} />
            </div>
          </Container>
        </Col>
        <Col md={18}>
          <Row gutter={5}>
            <Col md={18}>
              <MapGL width="100%" height="100%" />
            </Col>
            <Col md={6}>
              <Container title="Manufactures">
                <Space
                  direction="vertical"
                  align="center"
                  style={{ fontSize: 28, fontWeight: 'bold', width: '100%' }}
                >
                  <BuildOutlined />
                  <span style={{ color: PRIMARY }}>12</span>
                </Space>
                <div style={{ textAlign: 'center', color: PRIMARY }}>
                  Pop 10M or greater
                </div>
              </Container>
              <Container title="Distributors">
                <Space
                  direction="vertical"
                  align="center"
                  style={{ fontSize: 28, fontWeight: 'bold', width: '100%' }}
                >
                  <HomeOutlined />
                  <span style={{ color: SECONDARY }}>2250</span>
                </Space>
              </Container>
            </Col>
            <Col md={24} style={{ marginTop: 5 }}>
              <Container title="Statewise Variance" enableFullScreen>
                <Bar />
              </Container>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={5}>
        <Col md={6} xs={24}>
          <Container title="% YTD vs Previous Years">
            <YTD />
          </Container>
        </Col>
        <Col md={6} xs={24}>
          <Container title="Company Performance">
            <Gauge />
          </Container>
        </Col>
        <Col md={6} xs={24}>
          <Container title="Quarterwise YOY Comparison">
            <YOY />
          </Container>
        </Col>
        <Col md={6} xs={24}>
          <Container title="Individual Performance">
            <Gauge />
          </Container>
        </Col>
      </Row>
    </DashboardLayout>
  );
}
